export const APPSTORE_LINK = 'https://apps.apple.com/se/app/view-fashion-discovery/id1661470674'
export const INSTAGRAM_LINK = 'https://www.instagram.com/join_view/'
